export const serverUrl = 'https://meeting-organizer-backend.herokuapp.com';